import React, { FC, useContext } from 'react';

import { VideoPlayerContext } from '../VideoPlayer/VideoPlayer';

export interface IVideoItem {
  alt: string;
  image: string;
  title: string;
  videoId: number;
}

interface IProps {
  items: IVideoItem[];
  anglerName: string;
}

const VideoList: FC<IProps> = props => {
  const videoState = useContext(VideoPlayerContext);
  const { items } = props;

  const toggleVideo = (videoId: number) => {
    videoState.setContext({ videoId });
  };

  return (
    <div className="video-list">
      {items.map((videoItem, index) => (
        <div
          key={videoItem.image}
          className="video-list__item"
          onClick={() => toggleVideo(videoItem.videoId)}
        >
          <div className="video-list__image-container">
            <img
              alt={videoItem.alt || `video ${index}`}
              src={videoItem.image}
              className="video-list__image"
            />
            <span className="video-list__tag">VIDEO</span>
          </div>
          <div className="video-list__title">{videoItem.title}</div>
        </div>
      ))}
    </div>
  );
};

export default VideoList;
